import React from 'react';
import PropTypes from 'prop-types';
import { Badge } from '@syneto/compass-react';
import { VALIDITY_LABEL, VALIDITY_STATUS } from '../../../helpers/ExpiryRule';

// The Maintenance Status badge mapping, shared by the maintenance row and the add-on rows.
const BADGE_APPEARANCE = Object.freeze({
	[VALIDITY_STATUS.ACTIVE]: 'success',
	[VALIDITY_STATUS.EXPIRING]: 'warning',
	[VALIDITY_STATUS.EXPIRED]: 'danger',
});

export const ValidityBadge = ({ status, label }) => {
	return <Badge appearance={BADGE_APPEARANCE[status]}>{label ?? VALIDITY_LABEL[status]}</Badge>;
};

ValidityBadge.propTypes = {
	status: PropTypes.oneOf(Object.values(VALIDITY_STATUS)).isRequired,
	label: PropTypes.string,
};
